import { useEffect, useState } from "react";

export const useResendTimer = (RESEND_OTP_TIMER) => {
    const [seconds, setSeconds] = useState(RESEND_OTP_TIMER || 30); // Initial countdown time in seconds
    const [isTimerRunning, setIsTimerRunning] = useState(false);

    useEffect(() => {
        let interval;
    
        const decrementTimer = () => {
          setSeconds((prevSeconds) => (prevSeconds > 0 ? prevSeconds - 1 : 0));
        };
    
        if (isTimerRunning) {
          interval = setInterval(decrementTimer, 1000);
        } else {
          clearInterval(interval);
        }
    
        return () => clearInterval(interval);
      }, [isTimerRunning]);

    return {
        seconds, 
        setSeconds,
        isTimerRunning, 
        setIsTimerRunning
    };
};